export default __webpack_public_path__ + "static/media/warning--crossroads--g5.0af73743.png";